import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/banner.jpg'
import _imports_1 from '../assets/img/empty.jpg'


const _hoisted_1 = { class: "page-home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = { class: "home-wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "apply-wrapper"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "报名信息")
], -1)
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = { for: "" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("联系人姓名：")
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = { for: "" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("联系人电话：")
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-item form-card-item form-card-personal-item" }
const _hoisted_16 = { for: "" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("联系人身份证明：")
const _hoisted_18 = { class: "upload" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("请上传联系人身份证件"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("支持JPG\\JPEG\\PNG格式图片，图片大小不超过2M")
], -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-item" }
const _hoisted_23 = { for: "" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("队伍名：")
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "form-item" }
const _hoisted_27 = { for: "" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("队伍logo：")
const _hoisted_29 = { class: "upload" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", null, "请上传队伍logo图片（如有），支持JPG\\JPEG\\PNG格式，图片大小不超过2M，图片比例为1:1", -1)
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "form-item" }
const _hoisted_33 = { for: "" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("队伍属性：")
const _hoisted_35 = { class: "form-select-wrapper" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "form-select-sub-wrapper" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "form-item form-agree-item" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode("我已阅读并同意")
const _hoisted_43 = /*#__PURE__*/_createElementVNode("b", null, "请仔细阅读条款，同意后请勾选！", -1)
const _hoisted_44 = { class: "form-item form-submit-item" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_46 = {
  key: 1,
  class: "works-wrapper"
}
const _hoisted_47 = {
  key: 0,
  class: "title"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", null, "提交作品", -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 1,
  class: "form-wrapper"
}
const _hoisted_51 = { class: "form-item" }
const _hoisted_52 = { for: "" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("作品名称：")
const _hoisted_54 = ["value"]
const _hoisted_55 = { class: "form-item form-works-pic-item" }
const _hoisted_56 = { for: "" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("作品主图：")
const _hoisted_58 = { class: "upload" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "支持JPG\\JPEG\\PNG格式图片，图片大小不超过2M，图片建议比例为4:3", -1)
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "form-item" }
const _hoisted_62 = { for: "" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("建设方向（可多选）：")
const _hoisted_64 = { class: "form-select-wrapper" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("p", { class: "form-info" }, [
  /*#__PURE__*/_createElementVNode("span", null, "参赛者可在一个作品中选择体现以上一个或多个数字乡村建设方向。（注意：同一参赛主体在相同建设方向下选择提交的作品数量不得超过3个）")
], -1)
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "form-item form-upload-item form-upload-file-item" }
const _hoisted_70 = { for: "" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode("作品：")
const _hoisted_72 = { class: "form-upload" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("p", { class: "form-info" }, [
  /*#__PURE__*/_createElementVNode("span", null, "请将单个参赛作品的作品文件及报名表以一个压缩包形式上传（支持RAR、ZIP格式），压缩包大小不超过1G，并以作品名称命名。（其中作品文件需保存为PPT/PDF格式；如有视频文件，格式需为MP4或MOV，清晰度不低于1080P，画面质量不低于1920*1080，画面比例为横版16:9）")
], -1)
const _hoisted_74 = { class: "upload" }
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "form-item" }
const _hoisted_77 = { for: "" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode("作品简介：")
const _hoisted_79 = { class: "form-textarea" }
const _hoisted_80 = ["value"]
const _hoisted_81 = /*#__PURE__*/_createTextVNode("/500")
const _hoisted_82 = { class: "form-item form-agree-item form-agree-letter-item" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode("我已阅读并同意")
const _hoisted_85 = /*#__PURE__*/_createElementVNode("b", null, "请仔细阅读条款，同意后请勾选！", -1)
const _hoisted_86 = { class: "form-item form-agree-item" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode("我已阅读并同意")
const _hoisted_89 = /*#__PURE__*/_createElementVNode("b", null, "请仔细阅读条款，同意后请勾选！", -1)
const _hoisted_90 = { class: "form-item form-submit-item" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_92 = {
  key: 2,
  class: "not-started-wrapper"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("p", null, "作品上传通道将于7月1日正式开放", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("p", null, "敬请期待", -1)
const _hoisted_96 = [
  _hoisted_93,
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = {
  key: 2,
  class: "notice"
}
const _hoisted_98 = {
  key: 0,
  class: "apply-pop"
}
const _hoisted_99 = { class: "apply-pop-inner" }
const _hoisted_100 = { class: "apply-pop-top" }
const _hoisted_101 = { class: "apply-pop-btns" }
const _hoisted_102 = {
  key: 1,
  class: "works-list-pop apply-pop"
}
const _hoisted_103 = { class: "works-list-pop-inner apply-pop-inner" }
const _hoisted_104 = { class: "works-list-pop-top apply-pop-top" }
const _hoisted_105 = {
  key: 0,
  class: "works-list-pop-container"
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("h4", null, "历史作品", -1)
const _hoisted_107 = { class: "works-list-pop-list" }
const _hoisted_108 = ["onClick"]
const _hoisted_109 = ["onClick"]
const _hoisted_110 = { class: "apply-pop-btns" }
const _hoisted_111 = {
  key: 1,
  class: "apply-pop-status"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-jinggao1" }, null, -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("h4", null, "暂无作品", -1)
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = {
  key: 2,
  class: "apply-pop"
}
const _hoisted_116 = { class: "apply-pop-inner" }
const _hoisted_117 = { class: "apply-pop-top" }
const _hoisted_118 = /*#__PURE__*/_createTextVNode("上传作品需要到电脑端完成哦")
const _hoisted_119 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_120 = /*#__PURE__*/_createTextVNode("链接，去电脑端上传作品")
const _hoisted_121 = {
  key: 3,
  class: "apply-pop confirm-pop"
}
const _hoisted_122 = { class: "apply-pop-inner" }
const _hoisted_123 = { class: "apply-pop-top" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("p", null, "确认删除吗？", -1)
const _hoisted_125 = { class: "apply-pop-btns" }
const _hoisted_126 = {
  key: 4,
  class: "apply-pop works-over-pop"
}
const _hoisted_127 = { class: "apply-pop-inner" }
const _hoisted_128 = { class: "apply-pop-top" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("h4", null, "提交失败", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("同一参赛主体在相同建设方向下提交的相似作品数量不得超过3个。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("您可以调整参赛方向后重试。")
], -1)
const _hoisted_131 = { class: "apply-pop-btns" }
const _hoisted_132 = {
  key: 5,
  class: "apply-pop"
}
const _hoisted_133 = { class: "apply-pop-inner" }
const _hoisted_134 = { class: "apply-pop-top" }
const _hoisted_135 = { class: "apply-pop-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Upload = _resolveComponent("Upload")!
  const _component_Pop = _resolveComponent("Pop")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["nav", [!_ctx.isApplyed && 'no-apply']])
      }, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTab(0))),
          class: _normalizeClass([_ctx.curIndex == 0 && 'active'])
        }, "在线报名", 2),
        _withDirectives(_createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTab(1))),
          class: _normalizeClass([_ctx.curIndex == 1 && 'active'])
        }, "提交作品", 2), [
          [_vShow, _ctx.isApplyed]
        ])
      ], 2),
      (_ctx.isGetInfoed)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _withDirectives(_createElementVNode("b", null, null, 512), [
                    [_vShow, _ctx.applyFormRule.name.isReuired]
                  ]),
                  _hoisted_9
                ]),
                _createElementVNode("input", {
                  "data-name": "name",
                  value: _ctx.applyFormData.name,
                  type: "text",
                  placeholder: "请输入联系人姓名",
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                  onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
                  onPropertychange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                  onCompositionstart: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isInputZh = true)),
                  onCompositionend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.compositionend && _ctx.compositionend(...args)))
                }, null, 40, _hoisted_10),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.name.error), 513), [
                  [_vShow, _ctx.applyFormRule.name.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, [
                  _withDirectives(_createElementVNode("b", null, null, 512), [
                    [_vShow, _ctx.applyFormRule.tel.isReuired]
                  ]),
                  _hoisted_13
                ]),
                _createElementVNode("input", {
                  "data-name": "tel",
                  value: _ctx.applyFormData.tel,
                  type: "text",
                  placeholder: "请输入联系人电话",
                  onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                  onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
                  onPropertychange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                  onCompositionstart: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isInputZh = true)),
                  onCompositionend: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.compositionend && _ctx.compositionend(...args)))
                }, null, 40, _hoisted_14),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.tel.error), 513), [
                  [_vShow, _ctx.applyFormRule.tel.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("b", null, null, 512), [
                    [_vShow, _ctx.applyFormRule.idcardPic.isReuired]
                  ]),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_Upload, {
                    data: {
                                accept: '.JPG,.JPEG,.PNG,.jpg,.jpeg,.png', 
                                size: 2, 
                                maxLen: 1, 
                                formIndex: 0, 
                                name: 'idcardPic', 
                                preview: true, 
                                uploadIconClass: 'icon-plus-circle', 
                                uploadText: '上传身份证正面', 
                                imgs: _ctx.applyFormData.idcardPic
                            },
                    onUploaderror: _ctx.uploaderror,
                    onUploaded: _ctx.uploaded
                  }, null, 8, ["data", "onUploaderror", "onUploaded"]),
                  _createVNode(_component_Upload, {
                    data: {
                                accept: '.JPG,.JPEG,.PNG,.jpg,.jpeg,.png', 
                                size: 2, 
                                maxLen: 1, 
                                formIndex: 0, 
                                name: 'idcardBackPic', 
                                preview: true, 
                                uploadIconClass: 'icon-plus-circle', 
                                uploadText: '上传身份证背面', 
                                imgs: _ctx.applyFormData.idcardBackPic
                            },
                    onUploaderror: _ctx.uploaderror,
                    onUploaded: _ctx.uploaded
                  }, null, 8, ["data", "onUploaderror", "onUploaded"]),
                  _createElementVNode("input", {
                    "data-name": "idcardPic",
                    value: _ctx.applyFormData.idcardPic,
                    type: "hidden"
                  }, null, 8, _hoisted_20),
                  _createElementVNode("input", {
                    "data-name": "idcardBackPic",
                    value: _ctx.applyFormData.idcardBackPic,
                    type: "hidden"
                  }, null, 8, _hoisted_21)
                ]),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.idcardPic.error), 513), [
                  [_vShow, _ctx.applyFormRule.idcardPic.error]
                ]),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.idcardBackPic.error), 513), [
                  [_vShow, _ctx.applyFormRule.idcardBackPic.error && !_ctx.applyFormRule.idcardPic.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, [
                  _withDirectives(_createElementVNode("b", null, null, 512), [
                    [_vShow, _ctx.applyFormRule.teamName.isReuired]
                  ]),
                  _hoisted_24
                ]),
                _createElementVNode("input", {
                  "data-name": "teamName",
                  value: _ctx.applyFormData.teamName,
                  type: "text",
                  maxlength: "10",
                  placeholder: "请输入队伍名称（不超过10个字）",
                  onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                  onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
                  onPropertychange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                  onCompositionstart: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isInputZh = true)),
                  onCompositionend: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.compositionend && _ctx.compositionend(...args)))
                }, null, 40, _hoisted_25),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.teamName.error), 513), [
                  [_vShow, _ctx.applyFormRule.teamName.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, [
                  _withDirectives(_createElementVNode("b", null, null, 512), [
                    [_vShow, _ctx.applyFormRule.teamPic.isReuired]
                  ]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Upload, {
                    data: {
                                accept: '.JPG,.JPEG,.PNG,.jpg,.jpeg,.png', 
                                size: 2, 
                                maxLen: 1, 
                                formIndex: 0, 
                                name: 'teamPic', 
                                preview: true, 
                                imgs: _ctx.applyFormData.teamPic
                            },
                    onUploaderror: _ctx.uploaderror,
                    onUploaded: _ctx.uploaded
                  }, null, 8, ["data", "onUploaderror", "onUploaded"]),
                  _hoisted_30,
                  _createElementVNode("input", {
                    "data-name": "teamPic",
                    value: _ctx.applyFormData.teamPic,
                    type: "hidden"
                  }, null, 8, _hoisted_31)
                ]),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.teamPic.error), 513), [
                  [_vShow, _ctx.applyFormRule.teamPic.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("label", _hoisted_33, [
                  _withDirectives(_createElementVNode("b", null, null, 512), [
                    [_vShow, _ctx.applyFormRule.team.isReuired]
                  ]),
                  _hoisted_34
                ]),
                _createElementVNode("div", _hoisted_35, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamAttrs, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(["form-select", [item.selected && 'active']]),
                      onClick: ($event: any) => (_ctx.selectTeam(index))
                    }, _toDisplayString(item.name), 11, _hoisted_36))
                  }), 256))
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamAttrs[0].subList, (item, index) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: _normalizeClass(["form-select", [item.selected && 'active']]),
                      onClick: ($event: any) => (_ctx.selectTeam(index, 'issub'))
                    }, _toDisplayString(item.name), 11, _hoisted_38))
                  }), 256))
                ], 512), [
                  [_vShow, _ctx.teamAttrs[0].selected]
                ]),
                _createElementVNode("input", {
                  "data-name": "works",
                  value: _ctx.applyFormData.team,
                  type: "hidden"
                }, null, 8, _hoisted_39)
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("p", null, [
                  _createElementVNode("span", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.agree('isAgreed'))),
                    class: _normalizeClass([_ctx.applyFormData.isAgreed && 'checked'])
                  }, null, 2),
                  _hoisted_42,
                  _createElementVNode("i", {
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.popType = 1))
                  }, "《诚信承诺条款》"),
                  _hoisted_43
                ]),
                _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.applyFormRule.isAgreed.error), 513), [
                  [_vShow, _ctx.applyFormRule.isAgreed.error]
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("button", {
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, "提  交")
              ])
            ])
          ], 512)), [
            [_vShow, _ctx.curIndex == 0]
          ])
        : _createCommentVNode("", true),
      (_ctx.curIndex == 1 && !_ctx.isRefreshPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            (_ctx.canApply)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_47, _hoisted_49))
              : _createCommentVNode("", true),
            (_ctx.canApply)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("label", _hoisted_52, [
                      _withDirectives(_createElementVNode("b", null, null, 512), [
                        [_vShow, _ctx.worksFormRule.worksName.isReuired]
                      ]),
                      _hoisted_53
                    ]),
                    _createElementVNode("input", {
                      "data-name": "worksName",
                      value: _ctx.worksFormData.worksName,
                      type: "text",
                      placeholder: "请输入作品名称（不超过20个字）",
                      maxlength: "20",
                      onInput: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                      onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
                      onPropertychange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                      onCompositionstart: _cache[23] || (_cache[23] = ($event: any) => (_ctx.isInputZh = true)),
                      onCompositionend: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.compositionend && _ctx.compositionend(...args)))
                    }, null, 40, _hoisted_54),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.worksName.error), 513), [
                      [_vShow, _ctx.worksFormRule.worksName.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("label", _hoisted_56, [
                      _withDirectives(_createElementVNode("b", null, null, 512), [
                        [_vShow, _ctx.worksFormRule.worksPic.isReuired]
                      ]),
                      _hoisted_57
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createVNode(_component_Upload, {
                        data: {
                                accept: '.JPG,.JPEG,.PNG,.jpg,.jpeg,.png', 
                                size: 2, 
                                maxLen: 1, 
                                formIndex: 1, 
                                name: 'worksPic', 
                                preview: true,
                                imgs: _ctx.worksFormData.worksPic
                            },
                        onUploaderror: _ctx.uploaderror,
                        onUploaded: _ctx.uploaded
                      }, null, 8, ["data", "onUploaderror", "onUploaded"]),
                      _hoisted_59,
                      _createElementVNode("input", {
                        "data-name": "worksPic",
                        value: _ctx.worksFormData.worksPic,
                        type: "hidden"
                      }, null, 8, _hoisted_60)
                    ]),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.worksPic.error), 513), [
                      [_vShow, _ctx.worksFormRule.worksPic.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, [
                      _withDirectives(_createElementVNode("b", null, null, 512), [
                        [_vShow, _ctx.worksFormRule.themes.isReuired]
                      ]),
                      _hoisted_63
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.themeAttrs, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: _normalizeClass(["form-select", [item.selected && 'active']]),
                          onClick: ($event: any) => (_ctx.selectTheme(index))
                        }, [
                          _createTextVNode(_toDisplayString(item.name), 1),
                          _withDirectives(_createElementVNode("b", {
                            onClick: _withModifiers(($event: any) => (_ctx.removeSelected(index)), ["stop"]),
                            class: "iconfont icon-guanbi"
                          }, null, 8, _hoisted_66), [
                            [_vShow, item.selected]
                          ])
                        ], 10, _hoisted_65))
                      }), 256)),
                      _hoisted_67
                    ]),
                    _createElementVNode("input", {
                      "data-name": "works",
                      value: _ctx.worksFormData.themes,
                      type: "hidden"
                    }, null, 8, _hoisted_68),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.themes.error), 513), [
                      [_vShow, _ctx.worksFormRule.themes.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("label", _hoisted_70, [
                      _withDirectives(_createElementVNode("b", null, null, 512), [
                        [_vShow, _ctx.worksFormRule.works.isReuired]
                      ]),
                      _hoisted_71
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_Upload, {
                          data: {
                                    accept: '.RAR,.ZIP,.zip,.rar', 
                                    size: 1024, 
                                    maxLen: _ctx.worksFormRule.works.maxLen, 
                                    formIndex: 1, 
                                    name: 'works', 
                                    fileName: 'worksFileName',
                                    previewText: true, 
                                    previewBlank: true, 
                                    uploadText: '上传文件',
                                    imgs: _ctx.worksFormData.works,
                                    fileNames: _ctx.worksFormData.worksFileName
                                },
                          onUploaderror: _ctx.uploaderror,
                          onUploaded: _ctx.uploaded
                        }, null, 8, ["data", "onUploaderror", "onUploaded"]),
                        _createElementVNode("input", {
                          "data-name": "works",
                          value: _ctx.worksFormData.works,
                          type: "hidden"
                        }, null, 8, _hoisted_75)
                      ]),
                      _createElementVNode("a", {
                        href: "https://yunyingcdn.thecover.cn/o_1g2u8r5bj1p3e1jq513ou1sju1le79.pptx",
                        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                        download: "首届数字乡村创新设计大赛-初赛PPT模板.pptx",
                        class: "upload-template"
                      }, "大赛PPT模板下载"),
                      _createElementVNode("a", {
                        href: "https://yunyingcdn.thecover.cn/o_1g3b71ljd13mpnj8q5e1mur152sa.docx",
                        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                        download: "首届数字乡村创新设计大赛-报名表.docx",
                        class: "upload-template"
                      }, "报名表下载"),
                      _createElementVNode("a", {
                        href: "https://yunyingcdn.thecover.cn/o_1g3b71ljd1hpv86aojr4cuecb.docx",
                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.download && _ctx.download(...args))),
                        download: "首届数字乡村创新设计大赛-报名表填写模板.docx",
                        class: "upload-template"
                      }, "报名表填写模板下载")
                    ]),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.works.error), 513), [
                      [_vShow, _ctx.worksFormRule.works.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("label", _hoisted_77, [
                      _withDirectives(_createElementVNode("b", null, null, 512), [
                        [_vShow, _ctx.worksFormRule.brief.isReuired]
                      ]),
                      _hoisted_78
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("textarea", {
                        "data-name": "brief",
                        value: _ctx.worksFormData.brief,
                        maxlength: "500",
                        onInput: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                        onBlur: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.blur && _ctx.blur(...args))),
                        onPropertychange: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.changeInputValue && _ctx.changeInputValue(...args))),
                        onCompositionstart: _cache[31] || (_cache[31] = ($event: any) => (_ctx.isInputZh = true)),
                        onCompositionend: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.compositionend && _ctx.compositionend(...args)))
                      }, null, 40, _hoisted_80),
                      _createElementVNode("p", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.worksFormData.brief.length), 1),
                        _hoisted_81
                      ])
                    ]),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.brief.error), 513), [
                      [_vShow, _ctx.worksFormRule.brief.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("p", null, [
                      _createElementVNode("span", {
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.agree('isLetterAgreed'))),
                        class: _normalizeClass([_ctx.worksFormData.isLetterAgreed && 'checked'])
                      }, null, 2),
                      _hoisted_84,
                      _createElementVNode("i", {
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.popType = 2))
                      }, "《作品知识产权承诺书》"),
                      _hoisted_85
                    ]),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.isLetterAgreed.error), 513), [
                      [_vShow, _ctx.worksFormRule.isLetterAgreed.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _hoisted_87,
                    _createElementVNode("p", null, [
                      _createElementVNode("span", {
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.agree('isWorksAgreed'))),
                        class: _normalizeClass([_ctx.worksFormData.isWorksAgreed && 'checked'])
                      }, null, 2),
                      _hoisted_88,
                      _createElementVNode("i", {
                        onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.popType = 3))
                      }, "《大赛规则》"),
                      _hoisted_89
                    ]),
                    _withDirectives(_createElementVNode("i", { class: "error" }, _toDisplayString(_ctx.worksFormRule.isWorksAgreed.error), 513), [
                      [_vShow, _ctx.worksFormRule.isWorksAgreed.error]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_90, [
                    _hoisted_91,
                    _createElementVNode("button", {
                      onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                    }, "提  交")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_92, _hoisted_96))
          ]))
        : _createCommentVNode("", true),
      (_ctx.curIndex != 1 || _ctx.canApply)
        ? (_openBlock(), _createElementBlock("div", _hoisted_97, " 请注意：报名信息和作品一经上交，谨慎修改。一个队伍仅需要创建一个账号（账号为手机号，创建后不能修改）统一进行报名和作品提交，如发生一个队伍创建多个账号重复提交导致评选结果异常，由队伍自行承担后果！ "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.applyPopShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("div", _hoisted_100, [
              _createElementVNode("span", {
                onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.applyPopShow = false))
              })
            ]),
            _createElementVNode("h4", null, _toDisplayString(_ctx.isHandleWorksTab? '' : _ctx.isApplySuccess ? _ctx.curIndex == 1 ? '提交成功！' : '报名成功！' : '您已报过名！'), 1),
            _createElementVNode("div", _hoisted_101, [
              ((!_ctx.isApplySuccess || _ctx.curIndex == 1) && !_ctx.isHandleWorksTab)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "apply-pop-btn",
                    onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.applyPopShow = false))
                  }, "修改报名信息"))
                : _createCommentVNode("", true),
              (_ctx.worksList.length < 50)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "apply-pop-btn",
                    onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.goToWorks && _ctx.goToWorks(...args)))
                  }, "去上传作品"))
                : _createCommentVNode("", true),
              (_ctx.worksList.length)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: "apply-pop-btn",
                    onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.worksListShow = true))
                  }, "查看历史作品"))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.worksListShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("div", _hoisted_104, [
              _createElementVNode("span", {
                onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.closeWorksListPop && _ctx.closeWorksListPop(...args)))
              })
            ]),
            (_ctx.worksList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                  _hoisted_106,
                  _createElementVNode("div", _hoisted_107, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.worksList, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["works-list-pop-item", [_ctx.currentWorkItem && !_ctx.removeConfirmShow && _ctx.currentWorkItem._id === item._id && 'active']]),
                        onClick: ($event: any) => (_ctx.chooseWork(item))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.worksName), 1),
                        _createElementVNode("i", {
                          onClick: _withModifiers(($event: any) => (_ctx.chooseWork(item, 'remove')), ["stop"])
                        }, null, 8, _hoisted_109)
                      ], 10, _hoisted_108))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("span", {
                      class: "apply-pop-btn",
                      onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.editWorksFormData && _ctx.editWorksFormData(...args)))
                    }, "去修改")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_111, _hoisted_114))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.wapUploadPopShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
          _createElementVNode("div", _hoisted_116, [
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("span", {
                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.wapUploadPopShow = false))
              })
            ]),
            _createElementVNode("p", null, [
              _hoisted_118,
              _hoisted_119,
              _createElementVNode("span", {
                class: "copy-btn",
                onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.copy && _ctx.copy(...args)))
              }, "复制"),
              _hoisted_120
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.removeConfirmShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("span", {
                onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.closeRemovePop && _ctx.closeRemovePop(...args)))
              })
            ]),
            _hoisted_124,
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("span", {
                class: "apply-pop-btn",
                onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.closeRemovePop && _ctx.closeRemovePop(...args)))
              }, "取消"),
              _createElementVNode("span", {
                class: "apply-pop-btn",
                onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.removeWork && _ctx.removeWork(...args)))
              }, "确认")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.worksOverPopShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("span", {
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.worksOverPopShow = false))
              })
            ]),
            _hoisted_129,
            _hoisted_130,
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("span", {
                class: "apply-pop-btn",
                onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.worksOverPopShow = false))
              }, "知道了")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.popStautsData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("span", {
                onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.popStautsData = null))
              })
            ]),
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("span", {
                class: _normalizeClass(["iconfont", [_ctx.popStautsData.type ? 'icon-' + _ctx.popStautsData.type : '']])
              }, null, 2),
              _createElementVNode("h4", null, _toDisplayString(_ctx.popStautsData.text), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.popType)
      ? (_openBlock(), _createBlock(_component_Pop, {
          key: 6,
          type: _ctx.popType,
          onClose: _ctx.colsePop
        }, null, 8, ["type", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.toastData)
      ? (_openBlock(), _createBlock(_component_Toast, {
          key: 7,
          data: _ctx.toastData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}